module.exports = __webpack_public_path__ + "static/media/dogSideBgDesktop.d63bfc92.webp";